<template>
  <div class="pure-u-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="padding-30-reactive content box">
        <div class="pure-u-sm-1-5 pure-u-lg-1-4"></div>
        <div class="pure-u-sm-3-5 pure-u-lg-1-2">
          <form class="pure-u-1 pure-form pure-form-stacked" @submit.prevent="submit">
            <h3 class="pure-u-1 margin-bottom-10 responsive">First, let’s see if we can deliver to you</h3>
            <div class="pure-u-1 subtext margin-left-10">Already a Tavour member? <a class="link"
                                                                                     @click="$emit('login')">Login</a>
            </div>

            <div class="pure-u-1 spacing-30"></div>

            <label for="zipCode" class="pure-u-1">What's your delivery zip code?</label>
            <input class="pure-input-1 pure-u-1 " id="zipCode" type="tel" v-model="zipCode">
            <div class="text-red pure-u-1" v-if="showError">{{errorMsg}}</div>

            <div class="spacing-30 pure-u-1"></div>

            <label class="pure-u-1">Are you at least 21 years old?</label>
            <YesNo v-model="isOfAge" class="pure-u-1"/>
            <div class="text-red pure-u-1" v-if="!isOfAge">Must be at least 21 years old to sign up!</div>

            <div class="spacing-30 pure-u-1"></div>

            <Loading v-if="isBusy"/>

            <button class="pure-u-1 pure-button pure-button-primary block" type="submit" :disabled="!isOfAge" >Next</button>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import YesNo from './YesNo';
  import Loading from '../helpers/Loading';
  import ZipCode from '../../lib/zip_code';
  import store from '../../lib/store';
  import error from '../../lib/error';

  export default {
    name: 'ZipAndAge',
    components: { YesNo, Loading },
    created() {
      /* global ga */
      ga('send', 'pageview', `/${store.get('subscription')}/ZipAndAge`);
    },
    data() {
      return {
        isOfAge: true,
        zipCode: '',
        isBusy: false,
        showError: false,
        errorMsg: '',
      };
    },
    methods: {
      submit() {
        this.zipCodeLookup();
      },
      zipCodeLookup() {
        this.isBusy = true;
        ZipCode.lookUp(this.zipCode, (err, res) => {
          this.isBusy = false;
          if (err) {
            if (res) {
              if (res.statusCode === 404) {
                this.errorMsg = "Sorry, we don't currently deliver to your area.";
                this.showError = true;
              } else if (res.statusCode === 400) {
                this.errorMsg = 'Zip code is invalid, please try again.';
                this.showError = true;
              }
            } else {
              error.alert('An error occurred, try again.');
            }
          } else {
            this.showError = false;
            store.set('zipCode', res.body.zip_code);
            this.$emit('success');
          }
        });
      },
    },
    computed: {
      disabled() {
        const empty = this.zipCode.toString().length === 0;
        return empty || !this.isOfAge || this.isBusy;
      },
    },
  };
</script>


<style scoped>
  h3 {
    margin-top: 20px;
    margin-bottom: 30px;
  }

  .content {
    font-family: 'Open Sans', sans-serif !important;
  }

  .spacing-30 {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// ZipAndAge.vue?4f1d94f0